<div class="consotium_container">
  <form [formGroup]="myForm">
    <mat-card>
      <mat-card-content>
        <mat-form-field appearance="fill">
          <mat-label>Country Code</mat-label>
          <mat-select formControlName="countryCodeCtrl" placeholder="Country Code" required>
            <mat-option>
              <ngx-mat-select-search formControlName="countryCodeFilteringCtrl" [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Country Code">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let bank of filteredCountryCode | async" [value]="bank">
              {{bank.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Country Name</mat-label>
          <mat-select formControlName="countryCodeCtrl" placeholder="Country Name" required>
            <mat-option>
              <ngx-mat-select-search formControlName="countryCodeFilteringCtrl" [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Country Name">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let bank of filteredCountryCode | async" [value]="bank">
              {{bank.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Sector</mat-label>
          <mat-select formControlName="countryCodeCtrl" placeholder="Sector" required>
            <mat-option>
              <ngx-mat-select-search formControlName="countryCodeFilteringCtrl" [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Sector">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let bank of filteredCountryCode | async" [value]="bank">
              {{bank.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Country Currency</mat-label>
          <mat-select formControlName="countryCodeCtrl" placeholder="Country Currency" required>
            <mat-option>
              <ngx-mat-select-search formControlName="countryCodeFilteringCtrl" [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Country Currency">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let bank of filteredCountryCode | async" [value]="bank">
              {{bank.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>GST/VAT Type</mat-label>
          <mat-select formControlName="countryCodeCtrl" placeholder="GST/VAT Type" required>
            <mat-option>
              <ngx-mat-select-search formControlName="countryCodeFilteringCtrl" [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find GST/VAT Type">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let bank of filteredCountryCode | async" [value]="bank">
              {{bank.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="example-chip-list">
          <mat-label>Country Alias</mat-label>
          <mat-chip-grid #chipList>
            <mat-chip-row *ngFor="let _item of country" [removable]="true"
              (removed)="removeCountry(_item)">
              {{_item}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-row>
            <input placeholder="Country Alias" #countryInput formControlName="countryCtrl" [matAutocomplete]="auto"
              [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
          </mat-chip-grid>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedCountry($event)">
            <mat-option *ngFor="let _item of filteredCountry | async" [value]="_item">
              {{_item}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <br>
        <mat-checkbox class="remember-margin">State for the country is mandatory</mat-checkbox>
      </mat-card-content>

      <mat-card-content class="state_list">
        <table mat-table [dataSource]="stateDataSource">
          <ng-container matColumnDef="{{col.id}}" *ngFor="let col of stateCol;">
            <th mat-header-cell *matHeaderCellDef>
              <span *ngIf="col.id !== '$$edit'">
                {{col.name}}
              </span>
            </th>
            <td class="__last_td" mat-cell *matCellDef="let element;let stateColIndex = index;let last = last">
              <div *ngIf="((!element.isEdit || stateIndex!=stateColIndex+1) && last===false)"
                (dblclick)="element.isEdit=!editState(stateColIndex+1)">
                <div class="btn-edit" *ngIf="col.id === '$$edit'; spanHeader">
                  <button class="__delete_btn" *ngIf="last===false" (click)="removeState(stateColIndex)" mat-icon-button
                    color="primary">
                    <mat-icon class="__delete_icon">delete</mat-icon>
                  </button>
                </div>
                <span #spanHeader>
                  {{element[col.id]}}
                </span>
              </div>

              <div *ngIf="element.isEdit && stateIndex===stateColIndex+1" (clickOutside)="updateState(stateColIndex)"
                [excludeBeforeClick]=true [exclude]="'.__editable'" class="__editable">
                <div class="btn-edit" *ngIf="col.id === '$$edit'; else dataField">
                  <button class="__delete_btn" (click)="removeState(stateColIndex)" mat-icon-button color="primary"
                    focusable="false">
                    <mat-icon class="__delete_icon">delete</mat-icon>
                  </button>
                </div>
                <ng-template #dataField>
                  <mat-form-field>
                    <input type="text" [formControl]="getControlState(stateColIndex, col.id)" matInput
                      value="{{element[col.id]}}">
                    <mat-error *ngIf="getControlState(stateColIndex, col.id).hasError('required')">
                      Field is <strong>required</strong>
                    </mat-error>
                  </mat-form-field>
                </ng-template>
              </div>
              <div *ngIf="last===true">
                <mat-form-field *ngIf="col.id !== '$$edit'">
                  <input type="text" [formControl]="getControlState(stateColIndex, col.id)" matInput>
                  <mat-error *ngIf="getControlState(stateColIndex, col.id).hasError('required')">
                    Field is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
                <button class="__delete_btn" *ngIf="col.id== '$$edit'" mat-icon-button color="primary"
                  (keyup.Tab)="newState($event,stateColIndex)">
                  <mat-icon class="__delete_icon">delete</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="stateColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: stateColumns;"></tr>
        </table>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-content>
        <div class="document_list">
          <table mat-table [dataSource]="documentDataSource">
            <ng-container matColumnDef="{{col.id}}" *ngFor="let col of documentCol;let index = index">
              <th mat-header-cell *matHeaderCellDef>
                <span *ngIf="col.id !== '$$edit'">
                  {{col.name}}
                </span>
              </th>
              <td class="__text_center" mat-cell *matCellDef="let element;let documentColIndex = index;let last = last">
                <div *ngIf="!element.isEdit || documentIndex!=documentColIndex+1"
                  (dblclick)="element.isEdit=!editDocument(documentColIndex+1)">
                  <div class="btn-edit" *ngIf="col.id === '$$edit'; spanHeader">
                    <button class="__delete_btn" (click)="removeDocument(documentColIndex)" mat-icon-button
                      color="primary">
                      <mat-icon class="__delete_icon">delete</mat-icon>
                    </button>
                  </div>
                  <span #spanHeader *ngIf="col.id !== 'mandatory'">
                    {{element[col.id]}}
                  </span>
                  <mat-checkbox *ngIf="col.id === 'mandatory'" [checked]="element[col.id]"
                    class="margin_left remember-margin"></mat-checkbox>
                </div>

                <div *ngIf="element.isEdit && documentIndex===documentColIndex+1"
                  (clickOutside)="updateDocument(documentColIndex)" [excludeBeforeClick]=true [exclude]="'.__editable'"
                  class="__editable">
                  <div class="btn-edit" *ngIf="col.id === '$$edit'; else dataField">
                    <button class="__delete_btn" (click)="removeDocument(documentColIndex)" mat-icon-button
                      color="primary" focusable="false">
                      <mat-icon class="__delete_icon">delete</mat-icon>
                    </button>
                  </div>
                  <ng-template #dataField>
                    <mat-form-field *ngIf="col.id !== 'mandatory'">
                      <input type="text" [formControl]="getControlDocument(documentColIndex, col.id)" matInput
                        value="{{element[col.id]}}">
                      <mat-error *ngIf="getControlDocument(documentColIndex, col.id).hasError('required')">
                        Field is <strong>required</strong>
                      </mat-error>
                    </mat-form-field>
                    <mat-checkbox *ngIf="col.id === 'mandatory'" class="remember-margin"></mat-checkbox>
                  </ng-template>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="documentColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: documentColumns;"></tr>
          </table>
        </div>

        <mat-card-actions class="document_action">
          <button mat-button color="cancel">CANCEL</button>
          <button mat-button color="primary">SAVE</button>
        </mat-card-actions>
      </mat-card-content>
    </mat-card>
  </form>
</div>